import GitRepos from "../components/about/gitrepos";
import Presentation from "../components/about/presentation";
import Projects from "../components/about/projects";
import Skills from "../components/about/skills";
import Fade from "react-reveal/Fade";
import React, { useState} from "react";
import reversRetail from "../assets/img/projects/reversRetail/reversRetails_1.png"
import spotistats from "../assets/img/projects/spotistats/spotistats.png"

const projects = [
  {
    id: "revers_retail",
    name: "ReversRetail",
    logo: {
      src: "",
      alt: "logo revers retail",
    },
    description:
      "ReversRetail is a new way of buying proxies at retail price. We" +
      "take no cut on any proxy provider that we sell. How do we manage" +
      "to do that, we buy in bulk monthly allowing us to offer retail" +
      "pricing. Stop buying overpriced proxies and get them for retail!",
    link: {
      url: "https://www.reversretail.com/",
      text: "Visit website",
    },
    modal_information: {
      title: "",
      description: "As a frontend developer, my primary responsibility was to design and implement the user interface of a website. To achieve this," +
      "I employed the ReactJS framework and the NuxtUI library, which facilitated the utilization of pre-built components and streamlined the development process."+
      "The project was executed within a two-week time frame, which included a thorough testing phase to ensure optimal performance and user experience. "+
      "The final product, built with React and NuxtUI, delivered a highly responsive and visually appealing user interface."+
      "The use of NuxtUI library enabled efficient development and the two-week timeframe was sufficient to complete the project, inclusive of testing."+
      "I take pride in having successfully delivered the project, meeting all the requirements and standards.",
    }
  },
  {
    id: "Spotify Stats",
    name: "Spotify Stats",
    description:
      "Using the Spotify API to collect data on top artists and most listened genres from the account."+ 
      "Using ReactJS to display these statistics on a single web page, using graphs and diagrams to facilitate the visualization and understanding of the data.",
    link: {
      url: "https://spotify-stats-eight.vercel.app/",
      text: "Visit website",
    },
    modal_information: {
      title: "",
      description:
      "Using the Spotify API to collect data on top artists and most listened genres from the account."+ 
      "Using ReactJS to display these statistics on a single web page, using graphs and diagrams to facilitate the visualization and understanding of the data.",
      stack: [
        {
          logo: {
            src: "",
            alt: ""
          },
          name: ""
        }
      ]
    }
  } 
];

function About() {
  const [projectId, setProjectId] = useState()
  const projectToDisplay = projects.find(project => project.id === projectId)
  function definSrcImg(project){
    switch(project){
      case "ReversRetail" :
        return reversRetail
      case "Spotify Stats":
        return spotistats
    }
  }
  return (
    <div id="about">
      <Fade>
        <Presentation />
        <Projects projects={projects} setProjectId={setProjectId}/>
        <GitRepos  />
        <Skills />
      </Fade>
      <input type="checkbox" id="my-modal" className="modal-toggle"/>
      <div className="modal h-screen">
        {
          projectToDisplay && (
            <div className="modal-box h-screen bg-gradient-to-b from-zinc-800 to-zinc-900 border border-zinc-800 ">
              <h3 className="font-bold text-2xl mb-3">
                {projectToDisplay.name}
              </h3>
              <img src={definSrcImg(projectToDisplay.name)} alt={projectToDisplay.name}/>
              <p className="py-4 text-justify">
                {projectToDisplay.modal_information.description}
              </p>
              <div className="modal-action items-center">
                <a href={projectToDisplay.link.url} target="_blank" className="btn text-white" rel="noreferrer">
                  Visit website
                </a>
                <label htmlFor="my-modal" className="btn bg-red-800 hover:bg-red-600 text-white">
                  Close
                </label>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default About;
